<template>
  <div>
    <NavBar :admin="true" :items="items" />
		<v-main>
			<v-container>
        <v-progress-linear indeterminate color="primary" v-if="loading"></v-progress-linear>
        <template v-else>
          <DrugForm :drug="drug" :edit="true" />
        </template>
			</v-container>
		</v-main>
  </div>
</template>

<script>
import NavBar from "@/components/authentication/NavBar.vue";
import DrugForm from "@/components/drugs/DrugForm.vue";
import axios from "axios";

export default {
  name: "EditDrug",
  components: {
    NavBar,
    DrugForm
  },
  data: () => ({
    loading: false,
    drug: {name: '...'}
  }),
  computed: {
		items() {
			return [
				{
					text: this.$gettext("Dashboard"),
					disabled: false,
					link: true,
					to: "/admin/dashboard"
				},
				{
					text: this.$gettext("Drugs"),
					disabled: false,
          link: true,
          to: "/admin/dashboard/drugs"
        },
        {
					text: this.drug.name,
					disabled: true,
					link: true
				}
			];
		}
  },
  created() {
    const drugId = this.$route.params.did;
    this.loading = true;
    axios
			.get("/drugs/" + drugId)
				.then(response => {
          console.log(response.data);
          this.drug = response.data.drug;
          this.loading = false;
        })
				.catch(error => {
          console.log(error);
          this.loading = false;
        });
  }
}
</script>